import axios from 'axios';
import { SERVER_ENDPOINT, CLIENT_ID, CLIENT_SECRET } from '../Constants';

function getUserInfo(token, uid) {
  const url = '/api/userinfo/' + uid + '/';
  return axios({
    method: 'get',
    url,
    baseURL: SERVER_ENDPOINT,
    timeout: '10000',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      authorization: 'bearer ' + token,
    },
    data: {
      client_id: CLIENT_ID,
      client_secret: CLIENT_SECRET,
    },
  });
}

function createUserInfo(token, uid) {
  const url = '/api/userinfo/';
  return axios({
    method: 'post',
    url,
    baseURL: SERVER_ENDPOINT,
    timeout: '10000',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      authorization: 'bearer ' + token,
    },
    data: {
      client_id: CLIENT_ID,
      client_secret: CLIENT_SECRET,
    },
  });
}

function updateUserInfo(token, userInfo) {
  const url = '/api/userinfo/' + userInfo.id + '/';
  return axios({
    method: 'put',
    url,
    baseURL: SERVER_ENDPOINT,
    timeout: '10000',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      authorization: 'bearer ' + token,
    },
    data: {
      user: userInfo.id,
      dob: userInfo.dob,
      description: userInfo.description,
      teaching_info: userInfo.teaching_info,
      home_phone: userInfo.home_phone,
      mobile_phone: userInfo.mobile_phone,
      work_phone: userInfo.work_phone,
      skype: userInfo.skype,
      twitter: userInfo.twitter,
      facebook: userInfo.facebook,
      instagram: userInfo.instagram,
      website: userInfo.website,
      emergency_name: userInfo.emergency_name,
      emergency_phone: userInfo.emergency_phone,
      emergency_email: userInfo.emergency_email,
      is_public: userInfo.is_public,
      profile_img: userInfo.profile_img,
      profile_vid: userInfo.profile_vid,
      client_id: CLIENT_ID,
      client_secret: CLIENT_SECRET,
      contact_email: userInfo.contact_email,
    },
  });
}

// same as getUserInfo except no token because this is public data
// query can be username or ID
function getUserProfile(query) {
  const url = '/api/user/profile/' + query + '/';
  return axios({
    method: 'get',
    url,
    baseURL: SERVER_ENDPOINT,
    timeout: '10000',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    data: {
      client_id: CLIENT_ID,
      client_secret: CLIENT_SECRET,
    },
  });
}

export {
  getUserInfo,
  createUserInfo,
  updateUserInfo,
  getUserProfile,
};
